var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexiblePartnership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m53.834 4.578a15.022 15.022 0 0 1 .782 21.943l-6.976 6.979a3 3 0 0 1 -4.243 0 3 3 0 0 1 0-4.242l6.976-6.977a9.013 9.013 0 0 0 .042-12.686 9.294 9.294 0 0 0 -13 .189l-6.746 6.746a3 3 0 0 1 -4.243 0 3 3 0 0 1 0-4.243l6.7-6.7a15.261 15.261 0 0 1 20.708-1.009z",
    fill: "#3b97d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 44.085a8.953 8.953 0 0 0 2.589 6.322 9.294 9.294 0 0 0 13-.187l6.746-6.747a3 3 0 0 1 4.243 0 3 3 0 0 1 0 4.243l-6.7 6.7a15.261 15.261 0 0 1 -20.711 1.01 15.022 15.022 0 0 1 -.782-21.943l6.975-6.983a3 3 0 0 1 4.243 0 3 3 0 0 1 0 4.242l-6.976 6.98a8.951 8.951 0 0 0 -2.627 6.363z",
    fill: "#3b97d3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.607 23.636-4.95 4.95a2 2 0 0 1 -2.829 0l-1.414-1.414a2 2 0 0 1 0-2.829l4.83-4.83a3.117 3.117 0 0 1 4.2-.269 3.005 3.005 0 0 1 .161 4.392z",
    fill: "#2980ba"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.586 35.657-4.83 4.83a3.117 3.117 0 0 1 -4.2.269 3.005 3.005 0 0 1 -.161-4.392l4.95-4.95a2 2 0 0 1 2.829 0l1.414 1.414a2 2 0 0 1 -.002 2.829z",
    fill: "#2980ba"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0c419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 17a1 1 0 0 1 -.707-.293l-10-10a1 1 0 0 1 1.414-1.414l10 10a1 1 0 0 1 -.707 1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 14a1 1 0 0 1 -1-1v-10a1 1 0 0 1 2 0v10a1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 20h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 55a1 1 0 0 1 -.707-.293l-10-10a1 1 0 0 1 1.414-1.414l10 10a1 1 0 0 1 -.707 1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 58a1 1 0 0 1 -1-1v-10a1 1 0 0 1 2 0v10a1 1 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 42h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexiblePartnership);
export default __webpack_public_path__ + "static/media/flexible-partnership.3416aa52c7c9a949ab2453eb097e82a9.svg";
export { ForwardRef as ReactComponent };